<mat-card class="game-card" [class.whiteStyle]="whiteStyle">
  <mat-card-header>
    <mat-card-title>
      @if (game.status === 'draft') {
        {{ game.title }}
      } @else {
        <a [routerLink]="[urlLangPart+'/quiz/'+game.slug]">{{ game.title }}</a>
      }
    </mat-card-title>
    <div class="cost">
      @if (game.isFree) {
        <span class="free">FREE</span>
      } @else {
        <div><span>{{ cost }}</span><mat-icon color="accent" matTooltip="{{ cost }} token costs to play this game">token</mat-icon></div>
      }
    </div>
  </mat-card-header>
  <mat-card-content>
    <div class="game-cover">
      @if (game.gameIsPlayed) {
        <div class="played"><span>{{ 'game.details.played' | translate | async }}</span></div>
      }
      @if (game.coverImage) {
        @if (game.coverImage.mediumPart) {
          <img [src]="game.coverImage.sourceUrl + game.coverImage.mediumPart + '/' + game.coverImage.rawUrl" [alt]="game.coverImage.name" fetchpriority="high" width="450" height="300">
        } @else {
          <img [src]="game.coverImage.url" fetchpriority="high" width="450" height="300">
        }
      } @else {
        <img src="{{cdn}}/common/challenge_game_puzzle_rubik_icon.svg" [alt]="game.title" class="placeholder">
      }
    </div>
    <p>{{ game.description }}</p>
    <div class="game-details">
      <span class="item difficulty">
        {{ 'game.details.difficulty' | translate | async }}:
        <span [class]="game.difficulty">{{ game.difficulty }}</span>
      </span>
      <span class="item team-size">
        {{ 'game.details.players' | translate | async }}:
        <span>{{ game.minTeamSize }}-{{ game.maxTeamSize }}</span>
      </span>
      @if (game.totalRounds > 0) {
        <span class="item total-rounds">
          {{ 'game.details.total_questions' | translate | async }}:
          <span>{{ game.totalRounds }}</span>
        </span>
      }
      @if (game.category) {
        <span class="item category">
          {{ 'game.details.category' | translate | async }}:
          <span>{{ game.category }}</span>
        </span>
      }
      @if (game.creator) {
        <span class="item author">
          {{ 'game.details.author' | translate | async }}:
          <span>{{ game.creator.name }}</span>
        </span>
      }
      <span class="item available-on">
        {{ 'quiz.available_on' | translate | async }}:
        @for (lang of game.availableLangs; track lang) {
          <span>{{ lang }}<img [src]="'/assets/icons/lang/'+lang+'.svg'" alt="Flag" width="20" height="15"></span>
        }
      </span>
      <!-- <span class="item published">Published: <span> {{ game.publishedAt | date: 'short' }}</span></span> -->
    </div>
  </mat-card-content>
  <mat-card-actions>
    @if (game.status === 'draft') {
      <button mat-stroked-button color="warn" [routerLink]="[urlLangPart+'/profile/my-games']">{{ 'general.buttons.open_editor' | translate | async }}</button>
      <span class="draft">{{ 'game.details.draft' | translate | async }}</span>
    } @else {
      @if (game.status === 'published') {
        <a mat-flat-button color="secondary" routerLink="{{urlLangPart}}/quiz/{{ game.slug }}">
          {{ 'game.details.details' | translate | async }}
        </a>
      } @else {
        <button mat-stroked-button color="warn" [routerLink]="[urlLangPart+'/profile/my-games']">{{ 'general.buttons.open_editor' | translate | async }}</button>
      }
      <button mat-flat-button color="primary" (click)="onStartGame(game.id)" [disabled]="loading">
        {{ 'game.details.start_game' | translate | async }}
      </button>
    }
  </mat-card-actions>
</mat-card>
